import React from 'react';
import {FiCode, FiGlobe} from "react-icons/fi";
import ScrollAnimation from "react-animate-on-scroll";
import {AiOutlineMobile} from "react-icons/all";

const ServiceList = [
    {
        icon: <AiOutlineMobile />,
        title: 'Responsive Designs',
        description: 'We will build your websitesss to have dynamic appearance depending on screen size and orientation.'
    },
    {
        icon: <FiCode />,
        title: 'Custom Designs',
        description: 'There\'s less jargon. Less complication. We\'ll walk you through the entire procedure.'
    },
    {
        icon: <FiGlobe/>,
        title: 'SEO-Friendly',
        description: 'We create websites with SEO in mind. Your website will be optimized for search engines.'
    },
]

const ServiceOne = ({textAlign, serviceStyle}) => {
    return (
        <div className="row row--15 service-wrapper">
              {ServiceList.map( (val , i) => (
                <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <div className={`service ${serviceStyle} ${textAlign}`}>
                            <div className="icon">
                                {val.icon}
                            </div>
                            <div className="content">
                                <h4 className="title w-600">{val.title}</h4>
                                <p className="description b1 color-gray mb--0">{val.description}</p>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
export default ServiceOne;